<div class="developer-guide-container">
  <div class="header-section">
    <h1>Developer API Integration Guide</h1>
    <p class="subtitle">Integrate via API (no embedded SDK script)</p>
  </div>

  <div class="content-section">
    <div *ngIf="isLoading" class="loading-section">
      <p>Loading API integration guide...</p>
    </div>
    <div *ngIf="!isLoading" class="markdown-content">
      <markdown [data]="markdownContent"></markdown>
    </div>
  </div>
</div>
